import { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { Heading } from '@Green-Dot-Corporation/eureka-ui-typography';
import { Illustration, SIZES } from '@Green-Dot-Corporation/eureka-ui-media';
import CalloutActions from './CalloutActions';

// Styles
import './styles/illustration-callout.scss';

const { LARGE, MEDIUM, SMALL } = SIZES;

class IllustrationCallout extends PureComponent {
    static defaultProps = {
        illustrationAltText: '',
        headingLvl: 2,
        actions: [],
        isPageHeading: false,
        isCenterAligned: true,
        onActionClick: () => Promise.resolve(),
    };

    static propTypes = {
        contextCls: PropTypes.string,
        illustrationAltText: PropTypes.string,
        illustrationSize: PropTypes.string,
        illustrationSrc: PropTypes.string,
        headingLvl: PropTypes.number,
        actions: PropTypes.array,
        msg: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
        title: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
        isCenterAligned: PropTypes.bool,
        isPageHeading: PropTypes.bool,
        onActionClick: PropTypes.func,
        renderIllustration: PropTypes.func,
    };

    render() {
        const { contextCls, actions, title, msg, onActionClick, children } =
            this.props;
        const shouldRenderIllustration = this.getShouldRenderIllustration();
        const shouldRenderActions = actions.length > 0;
        const modCls = this.getModCls();

        return (
            <div className={cx(this.baseCls, modCls, contextCls)}>
                <div className={`${this.baseCls}__inner`}>
                    {!children && (
                        <Fragment>
                            {shouldRenderIllustration &&
                                this.renderIllustration()}
                            {(title || msg) && this.renderMessaging()}
                            {shouldRenderActions && (
                                <CalloutActions
                                    actions={actions}
                                    onActionClick={onActionClick}
                                />
                            )}
                        </Fragment>
                    )}
                    {children}
                </div>
            </div>
        );
    }

    renderIllustration = () => {
        const { renderIllustration } = this.props;

        return (
            <div className={`${this.baseCls}__illustration-container`}>
                {renderIllustration
                    ? renderIllustration()
                    : this.renderDefaultIllustration()}
            </div>
        );
    };

    renderDefaultIllustration = () => {
        const {
            illustrationAltText: altText,
            illustrationSrc: imgSrc,
            illustrationSize: size,
        } = this.props;
        const props = { altText, imgSrc, size };

        return <Illustration {...props} />;
    };

    renderMessaging = () => {
        const { title, msg, headingLvl } = this.props;

        return (
            <div className={`${this.baseCls}__text-container`}>
                {title && (
                    <div className={`${this.baseCls}__title-container`}>
                        <Heading
                            contextCls={`${this.baseCls}__title`}
                            headingLvl={headingLvl}
                        >
                            {title}
                        </Heading>
                    </div>
                )}
                {msg && (
                    <div className={`${this.baseCls}__msg-container`}>
                        <div className={`${this.baseCls}__msg-container-inner`}>
                            {msg}
                        </div>
                    </div>
                )}
            </div>
        );
    };

    getModCls = () => {
        const { illustrationSize, isPageHeading, isCenterAligned } = this.props;

        return {
            [`${this.baseCls}--ill-large`]: illustrationSize === LARGE,
            [`${this.baseCls}--ill-medium`]: illustrationSize === MEDIUM,
            [`${this.baseCls}--ill-small`]: illustrationSize === SMALL,
            [`${this.baseCls}--non-semantic`]: !isPageHeading,
            [`${this.baseCls}--center-align`]: isCenterAligned,
        };
    };

    getShouldRenderIllustration = () => {
        const { illustrationSrc, renderIllustration } = this.props;

        return !!illustrationSrc || !!renderIllustration;
    };

    baseCls = 'eureka-illustration-callout';
}

export default IllustrationCallout;
